import axios from 'axios';
import router from '../Router/index';

export default {
  namespaced: true,

  state: {
    print: false,
    blanks: [],
    PCNext: false,
    PCSave: false,
    feedbackSave: false,
    assessmentSave: false,
    assessmentNext: false,
    incidentBlankSaving: false,
    incidentBlankNext: false,
    commissionStatus: false,
    viewTwoPage: false,
    fromStudent: false,
    parentProject: {},
    projects: []
  },

  getters: {
    getBlanks(state) {
      return state.blanks;
    },
    getBlank(state, index) {
      return state.blanks[index];
    },
    getNextStatusPC(state) {
      return state.PCNext;
    },
    getSaveStatusPC(state) {
      return state.PCSave;
    },
    getStatusSaveFeedback(state) {
      return state.feedbackSave;
    },
    getSaveStatusAssessment(state) {
      return state.assessmentSave;
    },
    getNextStatusAssessment(state) {
      return state.assessmentNext;
    },
    getIncidentBlankSaving(state) {
      return state.incidentBlankSaving;
    },
    getIncidentBlankNext(state) {
      return state.incidentBlankNext;
    },
    getCommissionStatus(state) {
      return state.commissionStatus;
    }
  },

  mutations: {
    SET_PARENT(state, value) {
      state.parentProject = value;
    },
    SET_PROJECTS(state, value) {
      state.projects = value;
    },
    SET_PRINT(state, value) {
      state.print = value;
    },
    SET_FROM_STUDENT(state, value) {
      state.fromStudent = value;
    },
    VIEW_TWO_PAGE(state, value) {
      state.viewTwoPage = value;
    },
    PUSH_NEW(state, value) {
      state.blanks.push(value);
    },
    UPDATE_OLD(state, value, index) {
      state.blanks[index] = value;
    },
    CLEAR_ALL(state) {
      state.blanks = [];
    },
    SET_NEXT_PC(state, value) {
      state.PCNext = value;
    },
    SET_SAVE_PC(state, value) {
      state.PCSave = value;
    },
    SET_FEEDBACK_SAVE(state, value) {
      state.feedbackSave = value;
    },
    SET_SAVE_ASSESSMENT(state, value) {
      state.assessmentSave = value;
    },
    SET_NEXT_ASSESSMENT(state, value) {
      state.assessmentNext = value;
    },
    SET_INCIDENT_BLANK_SAVING(state, value) {
      state.incidentBlankSaving = value;
    },
    SET_INCIDENT_BLANK_NEXT(state, value) {
      state.incidentBlankNext = value;
    },
    SET_COMMISSION_STATUS(state, value) {
      state.commissionStatus = value;
    }
  },

  actions: {
    addBlank({ dispatch, commit }, value) {
      commit('PUSH_NEW', value);
    },
    updateNextPC({ commit }, value) {
      commit('SET_NEXT_PC', value);
    },
    updateSavePC({ commit }, value) {
      commit('SET_SAVE_PC', value);
    },
    updateSaveFeedback({ commit }, value) {
      commit('SET_FEEDBACK_SAVE', value);
    },

    updateNextAssessment({ commit }, value) {
      commit('SET_NEXT_ASSESSMENT', value);
    },
    updateSaveAssessment({ commit }, value) {
      commit('SET_SAVE_ASSESSMENT', value);
    },
    updateStatusSavingIncidentBlank({ commit }, value) {
      commit('SET_INCIDENT_BLANK_SAVING', value);
    },
    updateStatusNextIncidentBlank({ commit }, value) {
      commit('SET_INCIDENT_BLANK_NEXT', value);
    },

    updateCommissionStatus({ commit }, value) {
      commit('SET_COMMISSION_STATUS', value);
    }
  }
};
